
export enum WhoOptionsAirway
{
    Yes = 1,
    Recovery_Room_RN_removed_advanced_airway = 2,
    Transferred_to_ICU_Patient_intubated_and_ventilated = 3,
    No_advanced_airway_used = 4,
}

